
import { getStayRoomPrice, saveStayRoomPrice } from '@/api/stayRoomPrice';
import { Component, Vue } from 'vue-property-decorator';
import RoomPriceForm from './components/RoomPriceForm.vue';
import PricePartForm from './components/PricePartForm.vue';
import BasicPriceUpdate from './components/BasicPriceUpdate.vue';

@Component({
  components: {
    RoomPriceForm,
    PricePartForm,
    BasicPriceUpdate,
  },
})
export default class extends Vue {
  mounted() {
    this.getStayRoomPrice();
  }

  private priceInfo = {
    pricePartList: [],
    roomList: [],
  }

  private priceInfoOriginal = {
    pricePartList: [],
    roomList: [],
  }

  private loading = true;

  private getStayRoomPrice() {
    getStayRoomPrice().then((res) => {
      this.priceInfo = res.data;
      this.priceInfoOriginal = res.data;
      this.loading = false;
    });
  }

  private pricePartFormVisible = false;

  private handleVisiblePricePartForm() {
    this.pricePartFormVisible = !this.pricePartFormVisible;
  }

  private handleSaveStayRoomPrice() {
    this.$confirm('요금 정보를 저장하시겠습니까?', '요금정보 저장', {
      confirmButtonText: '저장',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      this.loading = true;
      saveStayRoomPrice(this.priceInfo).then(() => {
        this.$message.success('요금 정보를 저장했습니다.');
        this.getStayRoomPrice();
      }).catch(() => {
        this.loading = false;
        this.$message.error('요금 정보를 저장하는데 실패했습니다.');
      });
    });
  }

  private handleSelectRoom(room: any, targetRoom: any) {
    this.$confirm(`정말 ${room.name} 객실의 요금정보를 불러오시겠습니까?`, '요금 불러오기', {
      confirmButtonText: '예',
      cancelButtonText: '아니오',
      type: 'info',
    }).then(() => {
      targetRoom.prices = JSON.parse(JSON.stringify(room.prices));
      targetRoom.copyRoom = null;
    });
  }

  private handleSavePricePartList(pricePartList: any) {
    this.handleVisiblePricePartForm();
    pricePartList.forEach((pricePart: any, index: number) => {
      this.priceInfo.pricePartList = pricePartList;
      this.priceInfo.roomList.forEach((room: any) => {
        if (room.prices.length > index + 1) {
          room.prices[index + 1].pricePartName = pricePart.name;
        } else {
          room.prices.push({
            pricePartName: pricePart.name,
            weekdayPrice: 0,
            fridayPrice: 0,
            saturdayPrice: 0,
            sundayPrice: 0,
            holidayPrice: 0,
            holidayBeforePrice: 0,
          });
        }
      });
    });
  }

  private handleDeletePricePart(index: number) {
    this.priceInfo.pricePartList.splice(index, 1);
    this.priceInfo.roomList.forEach((room: any) => {
      room.prices.splice(index + 1, 1);
    });
  }

  private bedType(room: any) {
    const str: any = [];
    console.log(room);
    if (room.singleBedNum > 0) str.push(`싱글베드${room.singleBedNum}`);
    if (room.doubleBedNum > 0) str.push(` 더블베드${room.doubleBedNum}`);
    if (room.twinBedNum > 0) str.push(` 트윈베드${room.twinBedNum}`);
    if (room.queenBedNum > 0) str.push(` 퀸베드${room.queenBedNum}`);
    if (room.kingBedNum > 0) str.push(` 킹베드${room.kingBedNum}`);
    if (room.beddingNum > 0) str.push(` 침구세트${room.beddingNum}`);
    return str.join(', ');
  }
}
